export default __webpack_public_path__ + "static/media/Search_light.9cbe3850.svg";